import dayjs, { type Dayjs } from "dayjs";
import type { Staff } from "../../api-models";

type StaffFormValues = Omit<Partial<Staff>, "joinDate"> & { joinDate?: Dayjs | null };

// staffFormToRequest turns form values into the write request: the date picker holds a
// dayjs value and the API wants a plain YYYY-MM-DD (or nothing).
export function staffFormToRequest(values: StaffFormValues) {
  return { ...values, joinDate: values.joinDate ? values.joinDate.format("YYYY-MM-DD") : undefined };
}

// staffToFormValues is the inverse for the edit modal.
export function staffToFormValues(s: Staff): StaffFormValues {
  return { ...s, joinDate: s.joinDate ? dayjs(s.joinDate) : null };
}
